import { CandidateMatchType } from '@/api/apis/resources';

const commonStyles = 'p-1 text-s-r rounded-lg';

export const MatchCell = ({ matchType }: { matchType: CandidateMatchType }) => {
  switch (matchType) {
    case CandidateMatchType.Perfect:
      return <span className={`${commonStyles} bg-success-70 text-success-5`}>Best Match</span>;
    case CandidateMatchType.Medium:
      return <span className={`${commonStyles} bg-warning-80 text-warning-5`}>Medium Match</span>;
    case CandidateMatchType.Miss:
      return <span className={`${commonStyles} bg-danger-70 text-danger-5`}>Mismatch</span>;
    default:
      return null;
  }
};
